import { render } from "./TextComponent.vue?vue&type=template&id=0a01dcc9&scoped=true"
import script from "./TextComponent.vue?vue&type=script&lang=js"
export * from "./TextComponent.vue?vue&type=script&lang=js"

import "./TextComponent.vue?vue&type=style&index=0&id=0a01dcc9&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a01dcc9"]])

export default __exports__